import { ProjectChild, isProjectProductPosition } from "shared/types/Project"

export function getProductTotal(
  variants: ProjectChild[] | null | undefined
): number {
  return (
    variants?.reduce(
      (total, item) =>
        (isProjectProductPosition(item)
          ? item.quantity
          : getProductTotal(item.children)) + total,
      0
    ) || 0
  )
}
